import { Injectable } from '@angular/core';

import { MenuPermissionViewModel } from '@models/permission';

@Injectable({ providedIn: 'root' })
export class DeprecatedJsService {
  getOperationsObject(permissions: MenuPermissionViewModel[]): Record<string, boolean> {
    return (
      permissions?.reduce(
        (acc, permission) => {
          acc[permission.name] = true;
          return acc;
        },
        {} as Record<string, boolean>,
      ) || null
    );
  }
}
